import { Info } from "lucide-react";
import { siteConfig } from "../../../config/site";
import { Section } from "../ui/Section";

export function DisclaimerStrip() {
  return (
    <Section className="py-4">
      <div className="flex gap-3 rounded-lg border border-cyan-200/15 bg-cyan-200/[0.055] p-4 text-sm leading-6 text-slate-300">
        <Info className="mt-0.5 shrink-0 text-cyan-200" size={18} />
        <p>{siteConfig.disclaimer}</p>
      </div>
    </Section>
  );
}
